import { getOptionChainData } from "../../apis";
import { removeDuplicatesAndSort, getDistinctExpiryDates, getDecryptLocalStorage, getStorageWithMultiTabCheck } from "../../utils/global_functions";
import { BUSINESS_LAYER_RESPONSE, LOCAL_STORAGE_KEYS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { sendTouchlineRequest } from '../../apis/web_socket';


// ---BT-107433_SrikanthRao_16-08-2023_Option Calculator || Functional Implementation

async function _getStrikePricesBasedOnExpiry(objPayload) {

    try {
        if (objPayload?.instrumentName === 'EQUITIES') {
            objPayload.instrumentName = "OPTSTK";
        }
        else if (objPayload?.instrumentName === 'FUTCOM') {
            objPayload.instrumentName = "OPTFUT";
        }
        else {
            let instsub = objPayload?.instrumentName?.substr(3, 3);//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - Start
            objPayload.instrumentName = "OPT" + instsub;
        }
        const objResp = await getOptionChainData(objPayload);

        let arrOptionData = [];
        let arrDistinctOptExpiryDate = [];
        let objResultData = {};

        if (objResp?.status) {
            if (objResp?.data?.result.hits !== undefined) {
                if (objResp?.data?.result.hits.hits.length > 0) {
                    arrOptionData = objResp?.data?.result.hits.hits;
                    arrDistinctOptExpiryDate = getDistinctExpiryDates(arrOptionData);
                }
            }
        }
        if (arrOptionData?.length && arrDistinctOptExpiryDate?.length) {

            for (let i = 0; i < arrDistinctOptExpiryDate.length; i++) {
                objResultData[arrDistinctOptExpiryDate[i]] = [];
            }


            for (let i = 0; i < arrDistinctOptExpiryDate?.length; i++) {
                for (let j = 0; j < arrOptionData?.length; j++) {
                    if (arrDistinctOptExpiryDate[i] === arrOptionData[j]?._source?.nExpiryDate1) {
                        objResultData[arrDistinctOptExpiryDate[i]].push(arrOptionData[j]?._source?.nStrikePrice1);
                        arrOptionData?.slice(j, 1);
                    }
                }
            }
        }



        for (let i = 0; i < arrDistinctOptExpiryDate.length; i++) {
            objResultData[arrDistinctOptExpiryDate[i]] = removeDuplicatesAndSort(objResultData[arrDistinctOptExpiryDate[i]]);
        }


        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: objResultData };

    } catch (error) {
        console.log("error", error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }


}



export { _getStrikePricesBasedOnExpiry };
export function _getNumericMonth(sMonth) {
    try {
        let sRetval = "";
        switch (sMonth) {
            case "JAN":
                sRetval = "00";
                break;
            case "FEB":
                sRetval = "01";
                break;
            case "MAR":
                sRetval = "02";
                break;
            case "APR":
                sRetval = "03";
                break;
            case "MAY":
                sRetval = "04";
                break;
            case "JUN":
                sRetval = "05";
                break;
            case "JUL":
                sRetval = "06";
                break;
            case "AUG":
                sRetval = "07";
                break;
            case "SEP":
                sRetval = "08";
                break;
            case "OCT":
                sRetval = "09";
                break;
            case "NOV":
                sRetval = "10";
                break;
            case "DEC":
                sRetval = "11";
                break;
            default:
                break;
        }
        return sRetval;

    } catch (e) {
        console.log("error", e);
    }
}

export function _dateDiffernece(inputdate) {

    try {
        let day = parseInt(inputdate.substr(0, 2));
        let month = parseInt(_getNumericMonth(inputdate.substr(2, 3))) + 1;
        month = month < 10 ? "0" + month.toString() : month;
        let year = parseInt(inputdate.substr(-4));
        let newDate = month + '/' + day + '/' + year + ' ' + '00' + ':' + '00' + ':' + '00';
        let nextdate = new Date(newDate);
        let curruntData = new Date();
        let diffTime = Math.abs(nextdate - curruntData);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    } catch (error) {
        console.log("error", error);
    }
}

export const _getExpireDataInRedux = async (objScripSearch) => {
    let objLoginSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
    const nAllowedId = objLoginSession.nExchangesViewAllowed;

    const objPayload = {
        instrumentName: objScripSearch.sInstrumentName,
        symbol: objScripSearch.sSymbol,
        // allowedId: 880855135,
        allowedId: nAllowedId,
    };
    const objResp = await _getStrikePricesBasedOnExpiry(objPayload);
    return objResp;
};

export const _handleTouchlineSubscription = async (scrip, unsubscribe, pricetype) => {
    if (pricetype === "spot") {
        const arrScripsForSubscription = [{ exchangeId: scrip.mkt, token: scrip.token }];
        sendTouchlineRequest(arrScripsForSubscription);
    } else {
        const arrScripsForSubscription = [{ exchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scrip[WATCHLIST_GRID_INDEX.TOKEN] }];
        sendTouchlineRequest(arrScripsForSubscription, unsubscribe);
    }
};




